import React, { useEffect } from "react";
import styled from "styled-components";
import CompanyList from "./CompanyList/CompanyList";
import UserInfos from "./UserInfos/UserInfos";
import useClientItem from "./useClientItem";

const ClientItem = ({ clientData }) => {
  const { client, actions } = useClientItem();

  useEffect(() => {
    actions.initClient(clientData);
  }, [clientData]);

  return !client ? null : (
    <StyledClientItem className="mb-4" id={`leaditem${clientData.id}`}>
      <div className="row mx-0">
        <div className="col-12 col-lg-4 user-column px-0 py-3">
          <UserInfos />
        </div>
        <div className="col-12 col-lg-8 px-3 py-2">
          <CompanyList />
        </div>
      </div>
    </StyledClientItem>
  );
};

const StyledClientItem = styled.div`
  margin-top: 20px;
  padding-bottom: 24px;
  border-bottom: 1px solid var(--ds-slate-200);
`;

export default ClientItem;
